import { render, staticRenderFns } from "./editVariant.vue?vue&type=template&id=72d7a866&scoped=true"
import script from "./editVariant.vue?vue&type=script&lang=js"
export * from "./editVariant.vue?vue&type=script&lang=js"
import style0 from "./editVariant.vue?vue&type=style&index=0&id=72d7a866&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72d7a866",
  null
  
)

export default component.exports